define('modules/common/service/LoadingHandler',[], function() {
	var LoadingHandler = function() {
		var counter = 0;
		return {
			start: function() {
				counter = counter + 1;
			},
			stop: function() {
				if (counter > 0) {
					counter = counter - 1;
				}
			},
			isLoading: function() {
				return (counter > 0);
			},
			reset: function() {
				counter = 0;
			}
		};
	};

	return [LoadingHandler];
});
